export default function Socket(url, source_id) {
    return function(chart) {
        const protocol = window.location.protocol === 'https:' ? 'wss://' : 'ws://';
        url = url.endsWith('/') ? url + source_id : url + '/' + source_id
        const url2 = protocol + url.replace(/(^\w+:|^)\/\//, '')

        const ws = new WebSocket(url)

        ws.onerror = (err) => (console.error(err));
        ws.onmessage = (e) => {
            const data = JSON.parse(e.data);
            const method = data.type.replaceAll('.', '_');
            switch (method) {
                case 'mqtt_live':
                    chart.pushData(data)
                    break;
                case 'measurements_response':
                    chart.setData(data)
                    break
                case 'weight_response':
                    chart.setData(data)
                    break
                default:
                    console.error(`Unknown type: ${method}`)
            }
        }
        ws.onclose = (e) => {
        }
        return ws;
    }

}

export async function waitForOpenSocket(socket) {
    return new Promise((resolve) => {
        if(socket.readyState !== socket.OPEN) {
            socket.onopen = (e) => {return resolve()}
        } else {
            return resolve();
        }
    })
}